import { $tenant, IDENTITY_CONFIG, resolveTenant, setAutomaticReauthenticationSuppressed, useAuth } from '@msdk/common'
import { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { useRecoilValue } from 'recoil'

export function ClinicSwitch() {
  const { id } = useParams()
  const auth = useAuth()
  const tenant = useRecoilValue($tenant)

  useEffect(() => {
    if (!id) {
      return
    }

    const run = async () => {
      setAutomaticReauthenticationSuppressed(true)
      try {
        window.history.replaceState({}, document.title, '/' + tenant)
        await auth.removeUser(true)
        await auth.signIn({
          acr_values: `${IDENTITY_CONFIG.acr_values?.replace(/\s*business_unit:\S+/g, '').trim()} business_unit:${id}`,
          redirect_uri: `${window.__APP_CONFIG__.CLIENT}/${resolveTenant()}`,
        })
      } catch (error) {
        setAutomaticReauthenticationSuppressed(false)
        throw error
      }
    }

    run()
  }, [id])

  return <></>
}
